import { useCallback } from 'react'

import {
  uploadImage,
  uploadVideo,
} from '@/api/uploader'
import {
  MediaStatus,
  MediaType,
} from '@/model/media'
import {
  addMessageDraftMedia,
  updateMessageDraftMedia,
} from '@/redux/message-draft'
import { useAppDispatch } from '@/redux/utils'

export interface UseAddMediaParams {
  creatorId: number
  fanUserId: number
}

export const useAddMedia = ({
  creatorId,
  fanUserId,
}: UseAddMediaParams) => {
  const dispatch = useAppDispatch()

  return useCallback(async (files: File[] | FileList | null) => {
    if (files) {
      for (const file of files) {
        const type = file.type.startsWith('video') ? MediaType.Video : MediaType.Image
        const id = Math.random()
        dispatch(addMessageDraftMedia({
          creatorId,
          fanUserId,
          media: {
            id,
            type,
            status: MediaStatus.Pending,
          },
        }))

        const src = type === MediaType.Video
          ? await uploadVideo({ creatorId, file })
          : await uploadImage({ creatorId, file })
        if (!src) return

        dispatch(updateMessageDraftMedia({
          creatorId,
          fanUserId,
          media: {
            id,
            src,
            type,
            status: MediaStatus.Ready,
          },
        }))
      }
    }
  }, [dispatch, creatorId, fanUserId])
}
